export const convertObjectToSearchParams = (obj)=>{
    const params = new URLSearchParams();
    Object.entries(obj).forEach(([key, value])=>{
        if (value) {
            params.set(key, value);
        }
    });
    return params;
};

//# sourceMappingURL=convert-object-to-search-params.js.map